// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// Красивый селект
require('jquery-nice-select/js/jquery.nice-select');

// Отправка формы
require('vgformsender/dist/js/vgformsender');
require('sumoselect/jquery.sumoselect');
require('vgfiles/dist/js/vgfiles');